<template>
  <div>
    <Row class="detail-header">
      <span> {{ $t('BasicInformation') }}</span>
    </Row>
    <Row class="detail-content">
      <slot name="code-label"></slot>
      <!-- template1 实体店铺 工厂 其他-->
      <div
        v-if="clueDetail.tortType && clueDetail.tortType.indexOf('S') != '-1'"
      >
        <Row>
          <Col span="3" class="left-label">{{ $t('InfringementMethod') }}：</Col>
          <Col span="8" class="right-content">
            {{
              $t("tort_type." + clueDetail.tortType)
            }}
          </Col>
          <Col span="3" class="left-label">{{ $t('StoreName') }}：</Col>
          <Col
            span="8"
            class="right-content textover"
            :title="clueDetail.storeName"
          >
            {{ clueDetail.storeName }}
          </Col>

          <Col
            v-if="clueDetail.clueProduct" span="3" class="left-label"
          >
            {{ $t('InfringingProduct') }}：
          </Col>
          <Col
            v-if="clueDetail.clueProduct"
            span="8"
            class="right-content textover"
            :title="clueDetail.clueProduct.productName"
          >
            {{ clueDetail.clueProduct.productName }}
          </Col>
          <Col
            v-if="clueDetail.clueProduct" span="3" class="left-label"
          >
            {{ $t('SalesVolume') }}：
          </Col>
          <Col v-if="clueDetail.clueProduct" span="8" class="right-content">
            {{
              clueDetail.clueProduct.saleNum
            }}
          </Col>

          <Col
            v-if="clueDetail.hasProduct" span="3" class="left-label"
          >
            {{ $t('UnitPrice') }}
          </Col>
          <Col v-if="clueDetail.clueProduct" span="8" class="right-content">
            {{
              common.formateNumber(clueDetail.clueProduct.price || "")
            }}
          </Col>
          <Col span="3" class="left-label">{{ $t('InvestigationTime') }}：</Col>
          <Col span="8" class="right-content">{{ clueDetail.surveyDate }}</Col>
          <Col span="3" class="left-label">{{ $t('InvestigationAddress') }}：</Col>
          <Col
            span="8"
            class="right-content textover"
            :title="
              clueDetail.provinceName +
                clueDetail.cityName +
                clueDetail.areaName +
                clueDetail.address
            "
          >
            {{ clueDetail.provinceName }}{{ clueDetail.cityName
            }}{{ clueDetail.areaName }}{{ clueDetail.address }}
          </Col>
        </Row>
      </div>
      <!-- template2 电商平台-->
      <div v-if="clueDetail.tortType == 'E_EC'">
        <Row>
          <Col span="3" class="left-label">{{ $t('InfringementMethod') }}：</Col>
          <Col span="8" class="right-content">
            {{
              $t("tort_type." + clueDetail.tortType)
            }}
          </Col>
          <Col span="3" class="left-label">{{ $t('SalesChannel') }}：</Col>
          <Col span="8" class="right-content">
            {{ $t("ec_channel." + clueDetail.channelType) }}
          </Col>
          <Col
            v-if="clueDetail.channelType == 'OT'" span="3" class="left-label"
          >
            {{ $t('PlatformName') }}：
          </Col>
          <Col
            v-if="clueDetail.channelType == 'OT'"
            span="8"
            class="right-content textover"
            :title="clueDetail.platformName"
          >
            {{ clueDetail.platformName }}
          </Col>

          <Col span="3" class="left-label">{{ $t('StoreName') }}：</Col>
          <Col
            span="8"
            class="right-content textover"
            :title="clueDetail.storeName"
          >
            {{ clueDetail.storeName }}
            {{ clueDetail.dispenser && ['TT', 'PD', 'TS'].includes(clueDetail.channelType)?'---'+clueDetail.dispenser:'' }}
          </Col>
          <Col
            v-if="clueDetail.clueProduct" span="3" class="left-label"
          >
            {{ $t('InfringingProduct') }}：
          </Col>
          <Col
            v-if="clueDetail.clueProduct"
            span="8"
            class="right-content textover"
            :title="clueDetail.clueProduct.productName"
          >
            {{ clueDetail.clueProduct.productName }}
          </Col>

          <Col
            v-if="clueDetail.clueProduct" span="3" class="left-label"
          >
            {{ $t('SalesVolume') }}：
          </Col>
          <Col v-if="clueDetail.clueProduct" span="8" class="right-content">
            {{
              clueDetail.clueProduct.saleNum
            }}
          </Col>
          <Col
            v-if="clueDetail.channelType == 'AL'" span="3" class="left-label"
          >
            {{ $t('BulkOperation') }}：
          </Col>
          <Col
            v-if="clueDetail.channelType == 'AL' && clueDetail.clueProduct"
            span="8"
            class="right-content"
          >
            {{ clueDetail.clueProduct.batchNum }}
          </Col>

          <Col span="3" class="left-label">{{ $t('InvestigationTime') }}：</Col>
          <Col span="8" class="right-content">{{ clueDetail.surveyDate }}</Col>
          <Col span="3" class="left-label">{{ $t('StoreLink') }}：</Col>
          <Col
            span="8"
            class="right-content textover"
            :title="clueDetail.storeUrl"
          >
            <a :href="clueDetail.storeUrl" target="_blank">{{
              clueDetail.storeUrl
            }}</a>
          </Col>

          <Col
            v-if="clueDetail.hasProduct" span="3" class="left-label"
          >
            {{ $t('ProductLink') }}：
          </Col>
          <Col
            v-if="clueDetail.clueProduct"
            span="8"
            class="right-content textover"
            :title="clueDetail.clueProduct.productUrl"
          >
            <a :href="clueDetail.clueProduct.productUrl" target="_blank">{{
              clueDetail.clueProduct.productUrl
            }}</a>
          </Col>
          <Col
            v-if="clueDetail.hasProduct" span="3" class="left-label"
          >
            {{ $t('UnitPrice') }}：
          </Col>
          <Col v-if="clueDetail.clueProduct" span="8" class="right-content">
            {{
              common.formateNumber(clueDetail.clueProduct.price || "")
            }}
          </Col>
        </Row>
      </div>
      <!-- template3 网页链接-->
      <div v-if="clueDetail.tortType == 'E_WL'">
        <Row>
          <Col span="3" class="left-label">{{ $t('InfringementMethod') }}：</Col>
          <Col span="8" class="right-content">
            {{
              $t("tort_type." + clueDetail.tortType)
            }}
          </Col>
          <Col span="3" class="left-label">{{ $t('StoreName') }}：</Col>
          <Col
            span="8"
            class="right-content textover"
            :title="clueDetail.storeName"
          >
            {{ clueDetail.storeName }}
          </Col>

          <Col
            v-if="clueDetail.clueProduct" span="3" class="left-label"
          >
            {{ $t('InfringingProduct') }}：
          </Col>
          <Col
            v-if="clueDetail.clueProduct"
            span="8"
            class="right-content textover"
            :title="clueDetail.clueProduct.productName"
          >
            {{ clueDetail.clueProduct.productName }}
          </Col>
          <Col
            v-if="clueDetail.clueProduct" span="3" class="left-label"
          >
            {{ $t('SalesVolume') }}：
          </Col>
          <Col v-if="clueDetail.clueProduct" span="8" class="right-content">
            {{
              clueDetail.clueProduct.saleNum
            }}
          </Col>

          <Col span="3" class="left-label">{{ $t('InvestigationTime') }}：</Col>
          <Col span="8" class="right-content">{{ clueDetail.surveyDate }}</Col>
          <Col span="3" class="left-label">{{ $t('StoreLink') }}：</Col>
          <Col
            span="8"
            class="right-content textover"
            :title="clueDetail.storeUrl"
          >
            <a :href="clueDetail.storeUrl" target="_blank">{{
              clueDetail.storeUrl
            }}</a>
          </Col>

          <Col
            v-if="clueDetail.hasProduct" span="3" class="left-label"
          >
            {{ $t('ProductLink') }}：
          </Col>
          <Col
            v-if="clueDetail.hasProduct"
            span="8"
            class="right-content textover"
            :title="clueDetail.clueProduct.productUrl"
          >
            <a :href="clueDetail.clueProduct.productUrl" target="_blank">{{
              clueDetail.clueProduct.productUrl
            }}</a>
          </Col>
          <Col
            v-if="clueDetail.hasProduct" span="3" class="left-label"
          >
            {{ $t('UnitPrice') }}：
          </Col>
          <Col v-if="clueDetail.clueProduct" span="8" class="right-content">
            {{
              common.formateNumber(clueDetail.clueProduct.price || "")
            }}
          </Col>
        </Row>
      </div>
      <Row>
        <Col span="3" class="left-label">{{ $t('Remarks') }}：</Col>
        <Col
          span="20"
          class="right-content textover"
          :title="clueDetail.remark"
        >
          {{ clueDetail.remark }}
        </Col>
      </Row>
      <Row>
        <Col span="3" class="left-label">{{ $t('Attachment') }}：</Col>
        <Col span="20" class="right-content">
          <file-upload
            :base-url="baseUrl"
            :default-list="clueDetail.attachmentList || []"
            :upload-config="uploadConfig"
          />
        </Col>
      </Row>
      <Row class="detail-header">
        <span>{{ $t('Vendor') }}</span>
      </Row>
      <Row v-for="(bussiness, index) in tortList" :key="index">
        <tort-subject-info :default-data="bussiness" :base-url="baseUrl">
          <div slot="info-title">
            <Col
              span="24"
              class="tortSubject-sub-title"
              :style="{ color: mainColor.globalMainColor }"
            >
              [ {{ $t('Vendor') }}{{ index + 1 }} ]
            </Col>
          </div>
        </tort-subject-info>
      </Row>
      <Row v-if="tortList.length == 0" class="no-tips"> {{ $t('NoVendor') }}</Row>
      <Row class="detail-header">
        <span>{{ $t('Manufacturer') }}</span>
      </Row>
      <div v-if="clueManufacturerList">
        <Row
          v-for="(Manufacturer, index) in clueManufacturerList"
          :key="Manufacturer.id"
        >
          <tort-subject-info :default-data="Manufacturer" :base-url="baseUrl">
            <div slot="info-title">
              <Col
                span="24"
                class="tortSubject-sub-title"
                :style="{ color: mainColor.globalMainColor }"
              >
                [ {{ $t('Manufacturer') }}{{ index + 1 }} ]
              </Col>
            </div>
          </tort-subject-info>
        </Row>
        <Row v-if="clueManufacturerList.length == 0" class="no-tips">
          {{ $t('NoManufacturer') }}
        </Row>
      </div>
    </Row>
  </div>
</template>
<script>
import fileUpload from '@/components/common/fileUpload/fileUpload.vue'
import tortSubjectInfo from '@/view/clue/plugin/tortSubjectInfo.vue'
import styles from '@/assets/globalStyle.scss'
export default {
  components: {
    fileUpload,
    tortSubjectInfo
  },
  props: ['clueDetail', 'baseUrl'],
  data() {
    return {
      mainColor: styles,
      detail: '',
      type: 2,
      uploadConfig: {
        readOnly: true
      }
    }
  },
  computed: {
    tortList() {
      if (!this.clueDetail || !this.clueDetail.clueTortSubjectList) {
        return []
      }
      return this.clueDetail.clueTortSubjectList.filter((item, index) => {
        return item.category == 'S'
      })
    },
    clueManufacturerList() {
      if (!this.clueDetail || !this.clueDetail.clueTortSubjectList) {
        return []
      }
      return this.clueDetail.clueTortSubjectList.filter((item, index) => {
        return item.category == 'M'
      })
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {},
  updated() {},

  methods: {}
}
</script>
<style lang="scss" scoped>
.tortSubject-sub-title {
  padding: 5px 0px 10px 20px;
  font-weight: 700;
}
</style>
<style scoped lang="scss">
@import "./clueInfo.scss";
.no-tips {
  padding: 10px 10px 10px 30px;
  font-size: 14px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/view/clue/clueInfo.vue